import { render, staticRenderFns } from "./PnetUtilitiesDetail.vue?vue&type=template&id=6a49df8a&scoped=true"
import script from "./PnetUtilitiesDetail.vue?vue&type=script&lang=js"
export * from "./PnetUtilitiesDetail.vue?vue&type=script&lang=js"
import style0 from "./PnetUtilitiesDetail.vue?vue&type=style&index=0&id=6a49df8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a49df8a",
  null
  
)

export default component.exports